import { apiCallback } from 'api';

const defn = {
  post: apiCallback(
    {
      service: 'adtech',
      endpoint: 'adtech/banners',
      headers: {
        'wtr-uuid': '${uuid}',
      },
      verbs: ['post'],
      defaultVersion: 2,
    },
    'post',
  ),
};

export const v3search = {
  post: apiCallback(
    {
      service: 'adtech',
      endpoint: 'adtech/banners/search',
      headers: {
        'wtr-uuid': '${uuid}',
      },
      verbs: ['post'],
      defaultVersion: 3,
    },
    'post',
  ),
};

export const v3favourites = {
  post: apiCallback(
    {
      service: 'adtech',
      endpoint: 'adtech/banners/favourites',
      headers: {
        'wtr-uuid': '${uuid}',
      },
      verbs: ['post'],
      defaultVersion: 3,
    },
    'post',
  ),
};

export const offers = {
  post: apiCallback(
    {
      service: 'adtech',
      endpoint: 'adtech/banners/offers',
      headers: {
        'wtr-uuid': '${uuid}',
      },
      verbs: ['post'],
      defaultVersion: 3,
    },
    'post',
  ),
};

export default defn;
